import apiClient from './apiClient';

export interface BotMessage {
  id: number;
  admin_id: number;
  message_key: string;
  message_text: string;
  variables: string[] | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreateBotMessageRequest {
  message_key: string;
  message_text: string;
  variables?: string[];
  is_active?: boolean;
}

export interface UpdateBotMessageRequest {
  message_text?: string;
  variables?: string[];
  is_active?: boolean;
}

export interface ProcessMessageRequest {
  variables: Record<string, any>;
}

export interface ProcessMessageResponse {
  message_key: string;
  processed_message: string;
  variables_used: Record<string, any>;
}

class BotMessageService {
  // Listar todas as mensagens
  async getMessages(): Promise<{ success: boolean; data: BotMessage[] }> {
    const response = await apiClient.get('/bot-messages');
    return response.data;
  }

  // Buscar mensagem por chave
  async getMessageByKey(messageKey: string): Promise<{ success: boolean; data: BotMessage }> {
    const response = await apiClient.get(`/bot-messages/${messageKey}`);
    return response.data;
  }

  // Criar nova mensagem
  async createMessage(data: CreateBotMessageRequest): Promise<{ success: boolean; data: BotMessage; message: string }> {
    const response = await apiClient.post('/bot-messages', data);
    return response.data;
  }

  // Atualizar mensagem
  async updateMessage(messageKey: string, data: UpdateBotMessageRequest): Promise<{ success: boolean; data: BotMessage; message: string }> {
    const response = await apiClient.put(`/bot-messages/${messageKey}`, data);
    return response.data;
  }

  // Deletar mensagem
  async deleteMessage(messageKey: string): Promise<{ success: boolean; message: string }> {
    const response = await apiClient.delete(`/bot-messages/${messageKey}`);
    return response.data;
  }

  // Processar mensagem com variáveis
  async processMessage(messageKey: string, variables: Record<string, any>): Promise<{ success: boolean; data: ProcessMessageResponse }> {
    const response = await apiClient.post(`/bot-messages/${messageKey}/process`, { variables });
    return response.data;
  }

  // Criar mensagens padrão
  async createDefaultMessages(): Promise<{ success: boolean; message: string }> {
    const response = await apiClient.post('/bot-messages/create-defaults');
    return response.data;
  }
}

export default new BotMessageService();







